// ======================================================================
// 📁 File: src/modules/expense_management/ExpenseManagementLayout.jsx
// 📝 Purpose:
//   Main layout wrapper for Expense Management module
//   - Includes sidebar
//   - Handles content spacing
//   - Follows Service CRM layout architecture
// ======================================================================

import React, { useState } from "react";
import ExpenseManagementSidebar from "./layout/ExpenseManagementSidebar";

export default function ExpenseManagementLayout({ children }) {

  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  return (

    <div
      style={{
        minHeight: "100vh",
        background: "#f3f4f6",
      }}
    >

      {/* ========================================================= */}
      {/* Sidebar */}
      {/* ========================================================= */}

      <ExpenseManagementSidebar
        onToggle={(expanded) => setSidebarExpanded(expanded)}
      />

      {/* ========================================================= */}
      {/* Main Content */}
      {/* ========================================================= */}

      <main
        style={{
          marginLeft: sidebarExpanded ? 260 : 64,
          transition: "margin-left 0.22s ease",
          padding: 20,
        }}
      >
        {children}
      </main>

    </div>

  );

}